var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CuentaAtras',{on:{"tiempoTerminado":_vm.tiempoTerminado}}),_c('PageTitle',{staticClass:"strech",attrs:{"title":_vm.$t('nuevo_abono.titulo', { temporada: _vm.lista_abonados.nombre, abono: _vm.teatro.texto_abono })}}),_c('section',{staticClass:"padding-vertical-content"},[_c('Stepper',{ref:"stepper",attrs:{"steps":_vm.steps},scopedSlots:_vm._u([{key:"pasoSector",fn:function({ changeStep }){return [_c('SeleccionarZonaComponent',{on:{"zonaSeleccionada":(zona) => { 
                        _vm.zona_seleccionada = zona; 
                        changeStep(); 
                    }}})]}},{key:"pasoAsiento",fn:function({ changeStep }){return [_c('SeleccionarAsientosSga',{attrs:{"zona":_vm.zona_seleccionada},on:{"sesionCreada":items => {
                        _vm.items_carrito = items
                        changeStep();
                    },"volver":() => {
                        _vm.zona_seleccionada = null;
                        _vm.eliminarDatos();
                        changeStep(true);
                    }}})]}},{key:"pasoDatos",fn:function({ changeStep }){return [_c('DatosAbonosSGAComponent',{attrs:{"items_carrito":_vm.items_carrito},on:{"setDatosCobro":(jet_id, formulario, session_id) => {
                        _vm.setDatosCobro(jet_id, formulario, session_id);
                        changeStep();
                    },"volver":() => {
                        _vm.eliminarDatos();
                        changeStep(true);
                    }}})]}},{key:"pasoResumen",fn:function({ changeStep }){return [_c('ResumenCompra',{attrs:{"abonos":_vm.items_carrito,"jet_id":_vm.jet_id,"formulario":_vm.formulario},on:{"terminado":() => {
                        changeStep();
                    },"volver":() => {
                        changeStep(true);
                    }}})]}},{key:"pasoTarjeta",fn:function(){return [_c('ProcesarPago',{attrs:{"jet_id":_vm.jet_id,"session_id":_vm.session_id},on:{"terminado":() => {
                        _vm.changeStep();
                    }}})]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }